import React from 'react';

import { Radio, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Accordion, AccordionItem } from 'components/accordion';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive } from 'styles/constants';

const styles = StyleSheet.create({
  radioWrapper: {
    borderStyle: 'solid',
    borderTopColor: primitive.$greyFour,
    borderTopWidth: 1,
    width: '100%',
  },
  radioLabel: {
    flex: 1,
  },
  transactionDateOptionWrapper: {
    margin: 0,
  },
});

export const RadioWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.radioWrapper, style] });

export const CustomRadio = Radio.withConfig({
  width: 'full',
  flexDirection: 'row-reverse',
  paddingY: '$4',
  paddingX: '$4',
});

export const RadioLabel = withTypography({ fontSize: 'lg', style: styles.radioLabel });

export const TransactionDateOptionWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.transactionDateOptionWrapper, style] });

export const StyledAccordion = makeUclComponent(Accordion).withConfig({
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: primitive.$greyFour,
  borderRadius: primitive.$borderRadius,
  backgroundColor: getDesignToken('background-card'),
});

export const StyledAccordionItem = makeUclComponent(AccordionItem).withConfig({
  _accordionActivatorButton: {
    // override paddigY and paddigX values
    paddingY: '$4',
    paddingX: '$4',
  },
  _listItemTitle: {
    fontFamily: 'body',
    bold: true,
  },
});
